export default __webpack_public_path__ + "static/media/incoming-video-call.37a9f849.svg";